// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import { AiDeeplinkBanner } from "@/patterns/wpl/ad-banner/src";
import { UnleashBanner } from "@/patterns/wpl/ad-banner/src";

// Unleash banner styles
const unleashBannerWrapperStyles = css({
    display: "flex",
    justifyContent: "center",
    marginBlockEnd: "64px",
    marginBlockStart: "-64px",
    [media.above.sm]: {
        marginBlockStart: "-200px"
    }
});

export const LiftedBanner = () => {
    // once enabled this will serve the ai deeplink banner
    const aiGate: boolean = FeatureGates.checkGate("gwp-457-ai-deeplink-gate");
    const gate: boolean = FeatureGates.checkGate(
        "wac-lifted-bar-atlassian-presents-unleash"
    );
    if (gate) {
        return (
            <UFOSegment name="unleash-lifted-banner">
                <div css={unleashBannerWrapperStyles}>
                    <UnleashBanner />
                </div>
            </UFOSegment>
        );
    }

    if (aiGate) {
        return (
            <UFOSegment name="aideeplink-lifted-banner">
                <div css={unleashBannerWrapperStyles}>
                    <AiDeeplinkBanner />
                </div>
            </UFOSegment>
        );
    }
    return null;
};
